import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { SalarieCompetenceDto } from "../../../../../dto/GenApi.iNotPaie.Dto/SalarieCompetenceDto";
import $ from "jquery";
import moment from "moment";
import { ExperienceDto } from "../../../../../dto/GenApi.iNotPaie.Dto/ExperienceDto";

@Component
export default class ModalAjouterExperience extends Vue {
	@Prop()
	public salarie?: SalarieCompetenceDto = undefined;

	public estAjout = false;
	public experience?: ExperienceDto = undefined;

	public dateDebut?: string = "";
	public dateFin?: string = "";
	public poste?: string = "";
	public employeur?: string = "";

	public onExperienceChange(): void {
    	if (this.experience == undefined) {
			return;
		}

    	this.dateDebut = this.experience.DateDebut != undefined ? moment.utc(this.experience.DateDebut).format("YYYY-MM-DD") : "";
    	this.dateFin = this.experience.DateFin != undefined ? moment.utc(this.experience.DateFin).format("YYYY-MM-DD") : "";
    	this.poste = this.experience.Poste;
    	this.employeur = this.experience.Employeur;
	}

	public initialize(experience: ExperienceDto, estAjout: boolean, salarie?: SalarieCompetenceDto): void {
		this.reset();
    	this.salarie = salarie;
    	this.estAjout = estAjout;
    	this.experience = experience;

    	this.onExperienceChange();
    	this.$forceUpdate();
	}

	public enregistrer(): void {
    	if (this.salarie == undefined || this.experience == undefined || this.poste == undefined || this.poste == "") {
			return;
		}

    	this.experience.DateDebut = this.dateDebut != "" ? moment.utc(this.dateDebut).toDate() : undefined;
    	this.experience.DateFin = this.dateFin != "" ? moment.utc(this.dateFin).toDate() : undefined;
    	this.experience.Poste = this.poste;
    	this.experience.Employeur = this.employeur;

		this.$emit(this.estAjout ? "ajout" : "update", { experience: this.experience });
		this.annuler();
	}

	public reset(): void {
		this.salarie = undefined;
		this.estAjout = false;
		this.experience = undefined;
		this.dateDebut = "";
		this.dateFin = "";
		this.poste = "";
		this.employeur = "";
	}

	public annuler(): void {
		$("#modalAjouterExperience").modal("hide");
		this.reset();
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/competences/modals/ajouterExperience/ajouterExperience.ts